module.exports = __webpack_public_path__ + "media/images/processhorizon_white-8b3cc93c.svg";